import { Heart } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export function ShortlistButton({ property, className = "" }) {
  const { shortlist, toggleShortlist } = useAuth();
  const saved = shortlist.includes(property.id);
  return (
    <button
      type="button"
      data-testid={`property-shortlist-btn-${property.id}`}
      data-saved={saved}
      onClick={(e) => { e.stopPropagation(); toggleShortlist(property); }}
      aria-label={saved ? "Remove from shortlist" : "Save to shortlist"}
      aria-pressed={saved}
      className={`p-2 rounded-full border backdrop-blur-sm transition-colors ${saved ? "bg-[#D4AF37] border-[#D4AF37] text-black" : "bg-black/50 border-[#D4AF37]/40 text-[#F3E5AB] hover:bg-[#D4AF37]/20"} ${className}`}
    >
      <Heart size={14} fill={saved ? "currentColor" : "none"} />
    </button>
  );
}
